import { useAppLanguage } from '@/hooks/useAppLanguage';
import { useAppStore } from '@/lib/store';
import { getTranslation } from '@/constants/translations';
import Colors from '@/constants/colors';
import DetailPageLayout from '@/components/DetailPageLayout';
import DetailPageHeader from '@/components/DetailPageHeader';

const widgetOptions = [
  { type: 'currency' as const, key: 'currencyWidget' },
  { type: 'weather' as const, key: 'weatherWidget' },
  { type: 'air' as const, key: 'airWidget' },
  { type: 'calendar' as const, key: 'calendarWidget' },
  { type: 'holiday' as const, key: 'holidayWidget' },
  { type: 'word' as const, key: 'wordWidget' },
];

export default function WidgetsSettingsPage() {
  const { language } = useAppLanguage();
  const { toggleWidget, isWidgetEnabled } = useAppStore();

  return (
    <DetailPageLayout>
      <DetailPageHeader title={getTranslation('widgetsSettings', language)} />
      <div style={styles.content}>
        <p style={styles.subtitle}>
          {language === 'ru'
            ? 'Выберите какие виджеты показывать на главном экране'
            : language === 'pl'
            ? 'Wybierz które widżety mają być wyświetlane na głównym ekranie'
            : 'Choose which widgets to display on home screen'}
        </p>

        {widgetOptions.map((widget) => (
          <div key={widget.type} style={styles.widgetOption}>
            <span style={styles.widgetTitle}>
              {getTranslation(widget.key, language)}
            </span>

            <label style={styles.switch}>
              <input
                type="checkbox"
                checked={isWidgetEnabled(widget.type)}
                onChange={() => toggleWidget(widget.type)}
                style={styles.checkbox}
              />
              <span style={styles.slider}></span>
            </label>
          </div>
        ))}

      <div style={{ height: '40px' }} />
      </div>
    </DetailPageLayout>
  );
}

const styles = {
  content: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '16px',
  } as React.CSSProperties,

  subtitle: {
    fontSize: '14px',
    color: Colors.textSecondary,
    margin: 0,
    marginBottom: '8px',
  } as React.CSSProperties,

  widgetOption: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    backgroundColor: Colors.surface,
    borderRadius: '12px',
    border: `1px solid ${Colors.border}`,
  } as React.CSSProperties,

  widgetTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: Colors.text,
  } as React.CSSProperties,

  switch: {
    position: 'relative' as const,
    display: 'inline-block',
    width: '50px',
    height: '28px',
    cursor: 'pointer',
  } as React.CSSProperties,

  checkbox: {
    opacity: 0,
    width: 0,
    height: 0,
  } as React.CSSProperties,

  slider: {
    position: 'absolute' as const,
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: Colors.border,
    borderRadius: '28px',
    transition: 'background-color 0.3s ease',
    display: 'block',
  } as React.CSSProperties,
};

// Global styles for toggle switch
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  input[type="checkbox"]:checked + span {
    background-color: ${Colors.primary} !important;
  }

  input[type="checkbox"] + span::before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    display: block;
  }

  input[type="checkbox"]:checked + span::before {
    transform: translateX(22px);
  }
`;

if (typeof document !== 'undefined') {
  document.head.appendChild(styleSheet);
}
